import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import { KeyValueDefault } from "@/main/models/common";
import { ReassignBodyshopPartsCancelledForm } from "@/main/screens/order/cancelledParts/components/modalReassignBodyshopPartsCancelled/modalReassignBodyshopPartsCancelledUtils";
import { getTranslateByKey } from "@/main/services/utils";
import { convertStringForBoolean } from "@/main/services/utilsString";
import { useReasonReducer } from "@/main/store/reason";
import { Control, UseFormSetValue, useWatch } from "react-hook-form";
interface IReasonSection {
	control: Control<ReassignBodyshopPartsCancelledForm>;
	setValue: UseFormSetValue<ReassignBodyshopPartsCancelledForm>;
}

export function ReasonSection({ control, setValue }: Readonly<IReasonSection>) {
	const { reason: reasonReducer } = useReasonReducer();

	const watcherReason = useWatch({ control, name: "reason" });
	const isReasonOther = convertStringForBoolean(watcherReason?.default);

	return (
		<>
			<KogAutoCompleteControlled
				id="id-cancelledPartsReassignBodyshop-select-reason"
				nameCustom="reason"
				isDefaultValueUnique
				label={getTranslateByKey("information.reason")}
				control={control}
				rulesCustom={{ required: true }}
				setValueCustom={setValue}
				options={reasonReducer.data}
				isLoading={reasonReducer.isLoading}
				onChangeCustom={(option) => {
					if (option === null) return;
					if (convertStringForBoolean((option as KeyValueDefault)?.default)) {
						setValue("reasonDescription", "");
					}
				}}
			/>
			{isReasonOther && (
				<KogInputTextControlledNew
					required
					id="id-cancelledPartsReassignBodyshop-input-description"
					label={getTranslateByKey("information.description")}
					name="reasonDescription"
					control={control}
				/>
			)}
		</>
	);
}
